export function filterForIDsWithAssignment(assignmentData, ids) {
    return ids.filter((id) => Object.keys(assignmentData.data).filter((_id) => _id === id));
}
